const validateMsg = {
  phone: {
    error: "请输入正确的11位手机号码",
    empty: "请输入您的手机号码"
  },
  code: {
    error: "请输入6位验证码",
    empty: "请输入短信验证码"
  }
}

export default validateMsg



// WEBPACK FOOTER //
// ./src/app/utils/validateMsg.js